export const WINTER_SERVICE_MODULE = 'road-maintenance'

/**
 * The vehicles a winter service screen may pick from: the fleet's own autocomplete for
 * vehicles flagged for the winter service and configured for it. It answers with
 * `{ id, registration, label }` rather than a `name`, so the field has to be told what to
 * display.
 */
export const WINTER_SERVICE_VEHICLES_AUTOCOMPLETE = {
  module: 'fleet',
  route: 'vehicles/winter-service/autocomplete',
  custom_display_value: (item) => item?.registration || item?.label || ''
}

/**
 * The people a winter service screen may pick from - the driver of a task or of a
 * request. The endpoint answers with `{ id, name, email, phone_number }`.
 */
export const PEOPLE_AUTOCOMPLETE = {
  module: 'people',
  route: 'people/autocomplete'
}

export const ACTIVE_STATUS = {
  active: 'active',
  inactive: 'inactive'
}

// The colours the shared status indicator paints the dot with - the same pair
// the active/inactive statuses use everywhere else in the app.
export const ACTIVE_STATUS_COLORS = {
  [ACTIVE_STATUS.active]: {
    text: '#65AD45',
    background: '#ECFCCB'
  },
  [ACTIVE_STATUS.inactive]: {
    text: '#EF4444',
    background: '#FEE2E2'
  }
}
